import { Component } from '@angular/core';

@Component({
  selector: 'app-password-constraints',
  templateUrl: './password-constraints.component.html',
  styleUrls: ['./password-constraints.component.scss'],
})
export class PasswordConstraintsComponent {}
